import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { aggregatedClasses } from '@elliemae/ds-classnames';

var blockName = 'spinner';
var SpinnerContainer = aggregatedClasses('div')(blockName);
var SpinnerMessage = aggregatedClasses('span')(blockName, 'message');
var Spinner = aggregatedClasses('div')(blockName, 'spinner'); // TODO: do we want dynamic position of the text (top, right, bottom, left)?

var DSSpinner = function DSSpinner(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      innerRef = _ref.innerRef,
      message = _ref.message,
      size = _ref.size,
      otherProps = _objectWithoutProperties(_ref, ["containerProps", "innerRef", "message", "size"]);

  return /*#__PURE__*/React.createElement(SpinnerContainer, _extends({}, containerProps, {
    ref: innerRef,
    "aria-busy": true,
    "aria-label": message,
    "aria-live": "polite",
    role: "alert"
  }, otherProps), /*#__PURE__*/React.createElement(Spinner, {
    classProps: {
      size: size
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: "".concat(blockName, "-tl"),
    viewBox: "0 0 16.6 16.6",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1.5A15.6,15.6,0,0,0,.5,16.1,15.6,15.6,0,0,0,16.1.5Z",
    fill: "#408a90",
    stroke: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "".concat(blockName, "-tr"),
    viewBox: "0 0 16.6 16.6",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1,16.1A15.6,15.6,0,0,0,.5.5,15.6,15.6,0,0,0,16.1,16.1Z",
    fill: "#f7901e",
    stroke: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "".concat(blockName, "-br"),
    viewBox: "0 0 16.6 16.6",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.5.5A15.6,15.6,0,0,0,16.1,16.1,15.6,15.6,0,0,0,.5.5Z",
    fill: "#0067ab",
    stroke: "#fbfbfb"
  })), /*#__PURE__*/React.createElement("svg", {
    className: "".concat(blockName, "-bl"),
    viewBox: "0 0 16.6 16.6",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1.5A15.6,15.6,0,0,0,.5,16.1,15.6,15.6,0,0,0,16.1.5Z",
    fill: "#00acdc",
    stroke: "#fbfbfb"
  }))), message && /*#__PURE__*/React.createElement(SpinnerMessage, null, message));
};

DSSpinner.defaultProps = {
  containerProps: {},
  message: '',
  size: 'm'
};
var spinnerProps = {
  innerRef: PropTypes.object.description('ref to the component s container'),
  containerProps: PropTypes.object.description('Set of Properties attached to the main container'),
  message: PropTypes.string.description('Text below the spinner'),
  size: PropTypes.oneOf(['s', 'm', 'l']).description('Spinner size').defaultValue('m')
};
DSSpinner.propTypes = spinnerProps;
var SpinnerWithSchema = describe(DSSpinner);
SpinnerWithSchema.propTypes = spinnerProps;

export default DSSpinner;
export { DSSpinner, SpinnerWithSchema };
//# sourceMappingURL=DSSpinner.js.map
